import { ContactUsApiResponse } from './interfaces/contact-us-api-response.interface';
import { ContactUsRequestDto } from './interfaces/contact-us-request-dto.interface';

export const postContactUs = async (
  payload: ContactUsRequestDto,
  integrationId: string,
): Promise<ContactUsApiResponse> => {
  const response = await fetch('/api/contact-us', {
    method: 'POST',
    body: JSON.stringify({
      ...payload,
      integrationId,
    }),
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
  });

  const data = await response.json();

  if (response.ok) {
    return data;
  } else {
    throw Error(data.errorMessage || `Server error ${response.status}`);
  }
};
